<script setup>
import { ref, computed, defineProps, defineEmits, watchEffect } from 'vue';
import { useStore } from 'vuex'
import _ from 'lodash'
import Swal from 'sweetalert2';

const emit = defineEmits(['save']);

const props = defineProps({
  existingViolation: {
    type: Number
  },
  editable: {
    type: Boolean,
    default: true
  },
  violation_list: {
    type: Array,
    required: true
  }
});

const store = useStore();

const violation_list = computed(() => props.violation_list);

const selected_violation = ref(null);

const loading = computed(() => store.state.globals.loading);

const penaltyFee = computed(() => {
  const fee = _.find(violation_list.value, (v) => { 
    return v.id == selected_violation.value; 
  });
  if(!fee){
    return 0;
  }
  return fee.penalty_fee;
})

watchEffect(() => {
  if (props.existingViolation) {
    selected_violation.value = props.existingViolation;
  }
})

const handleSelectedViolation = () => {
  Swal.fire({
      title: "Update Violation",
      text: "Continue updating the violation?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#34c38f",
      cancelButtonColor: "#f46a6a",
      confirmButtonText: "Yes",
    }).then(async (result) => {
      if (result.value) {
        emit('save', selected_violation.value);
      }
    });
}

</script>

<template>
  <b-overlay :show="loading">
    <div class="card">
      <div class="card-body overflow-auto">
        <table class="table table-bordered table-sm table-light m-0 mb-3">
          <tbody>
            <tr>
              <th colspan="2" class="text-center">Base Violation</th>
            </tr>
            <tr>
              <td class="text-center">
                <select v-if="props.editable" required class="form-select" v-model="selected_violation">
                  <template v-for="option in violation_list" :key="option.id" >
                    <option :value="option.id">
                      {{ option.violation.name }}
                    </option>
                    <option class="article" disabled>
                      {{ option.violation.article }}
                    </option>
                  </template>
                </select>
                <select v-if="!props.editable" disabled class="form-select" :value="selected_violation">
                  <template v-for="option in violation_list" :key="option.id" >
                    <option :value="option.id">
                      {{ option.violation.name }}
                    </option>
                    <option class="article" disabled>
                      {{ option.violation.article }}
                    </option>
                  </template>
                </select>
              </td>
              <td class="no-wrap text-center align-middle">PHP {{ penaltyFee }}</td>
            </tr>
          </tbody>
        </table>
        <div class="row mx-1">
            <button @click="handleSelectedViolation" type="button" class="btn btn-info">
                <i class="ri-save-2-fill fs-14 mr-1 valign-middle"></i>
                Update Violation
            </button>
        </div>
      </div>
    </div>
  </b-overlay>
</template>

<style scoped>
select option{
  font-size:14px;  
}
select option.article{
  font-size:10px;  
}
.no-wrap{
  min-width: fit-content;
  width: 100px;
  white-space: nowrap;
}
td{
  padding:5px;
}
</style>
